// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as V3CustomTableContext$LiteracyplanetTupperware from "./V3CustomTableContext.res.mjs";

function V3CustomTableCell(props) {
  var children = props.children;
  var colIndex = props.colIndex;
  var rowIndex = props.rowIndex;
  var match = Curry._1(V3CustomTableContext$LiteracyplanetTupperware.use, undefined);
  var t = match.t;
  if (t === "InstructionAndHint") {
    if (colIndex === 0) {
      if (rowIndex === 0) {
        return React.createElement("div", {
                    className: ""
                  }, children);
      }
      if (rowIndex === 1) {
        return React.createElement("div", {
                    className: ""
                  }, children);
      }
      
    }
    
  } else if (t === "GridMatchLeftToRight") {
    if (colIndex === 0) {
      return React.createElement("div", {
                  className: "flex justify-end col-span-3"
                }, children);
    }
    if (colIndex === 1) {
      return React.createElement(React.Fragment, {}, React.createElement("div", {
                      className: "col-span-1 px-5"
                    }, React.createElement("div", {
                          className: "h-1/2 border-b border-black"
                        })), React.createElement("div", {
                      className: "col-span-5"
                    }, children));
    }
    
  } else {
    if (colIndex === 0) {
      return React.createElement(React.Fragment, {
                  children: Caml_option.some(React.createElement("div", {
                            className: "col-span-1 flex justify-end"
                          }, children))
                });
    }
    if (colIndex === 1) {
      return React.createElement("div", {
                  className: "flex col-span-8 ml-5"
                }, children);
    }
    
  }
  throw {
        RE_EXN_ID: "Match_failure",
        _1: [
          "V3CustomTableCell.res",
          4,
          2
        ],
        Error: new Error()
      };
}

var make = V3CustomTableCell;

var $$default = V3CustomTableCell;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
